import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import SystemNeoUmmiaLogoTextImage from "../../images/SystemNeoUmmiaLogoTextImage";
import {LogoTextSize} from "../../../controllers/SystemUmmiaLogoTextController";
import {kSystemIcons} from "../../../constants/icons";
import {useLocation, useNavigate} from "react-router-dom";
import {internalRoutes} from "../../../constants/internalRoutes";

export default function HomeDrawerHeader({onClosePressed}) {
    // Used in HomeDrawerHeader to display welcome message
    // and user related actions

    // PROPERTIES
    const location = useLocation();
    const navigate = useNavigate();
    const isHome = location.pathname === "/"

    // BUILD
    return (
        <div className={"w-full flex flex-col space-y-[12px] bg-gradient-to-br from-backgroundLight3 to-background pt-[12px]"}>
            <div className={"w-full flex justify-between items-start px-[12px]"}>
                <SystemNeoUmmiaLogoTextImage logoTextSize={LogoTextSize.XSMALL}
                                             onLogoPressed={!isHome ? () => navigate(internalRoutes.home) : null}
                                             extraClass={"mt-[3px]"} />
                <div className={"mt-[6px]"}
                     onClick={() => onClosePressed()}>
                    <i className={`material-icons cursor-pointer text-[20px] text-greyLight7 hover:text-greyLight11`}>
                        {kSystemIcons.cancel}
                    </i>
                </div>
            </div>
            <SystemCustomDivider color={"bg-greyLight3"} />
        </div>
    );
}